module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.isManager('finance')) ? _c('div', {
    staticClass: "hidden-md-and-down"
  }, [((_vm.isManager() && !_vm.rowData.paid) || _vm.isSuper()) ? _c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30fc143a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/UtilityControls.vue
// module id = 1401
// module chunks = 0